import { useNavigate } from 'react-router-dom';
import BackButton from './BackButton';
import './CommPage.css';
import React, { useState, useEffect } from 'react';

const CommPage = () => {
    const navigate = useNavigate();
  
    const [loading, setLoading] = useState(false);
    useEffect(() => {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 700);
    }, []);
  
    return (
      <div className="container">
        {loading ? (
          <div className="loader-container">
              <div className="spinner"></div>
          </div>
        ) : (
      <div className="item-page-four">
        <div className="overlay"></div>
        <table className="table">
            <thead>
                <tr>
                    <th>Направление</th>
                    <th colspan="3">Прайс</th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Луна</td>
                    <td>
                        <button className="layer-button">
                            100
                        </button>
                    </td>
                    <td>
                    <button className="layer-button">
                            200
                        </button>
                    </td>
                    <td>
                    <button className="layer-button">
                            300
                        </button>
                    </td>
                </tr>
                <tr>
                    <td>Венера</td>
                    <td>
                        <button className="layer-button">
                            400
                        </button>
                    </td>
                    <td>
                    <button className="layer-button">
                            500
                        </button>
                    </td>
                    <td>
                    <button className="layer-button">
                            600
                        </button>
                    </td>
                </tr>
                <tr>
                    <td>Марс</td>
                    <td>
                        <button className="layer-button">
                            700
                        </button>
                    </td>
                    <td>
                    <button className="layer-button">
                            800
                        </button>
                    </td>
                    <td>
                    <button className="layer-button">
                            900
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <form className="text-form">
        <fieldset className="search-form__fieldset">
          <label className="search-form__label search-form__label-display">
            <span className="search-form__label-text visually-hidden">Итоговая стоимость</span>
            <p class="expedition__value">1200</p>
          </label>
        </fieldset>
      </form>
      <button className="layer-button">
        Купить
      </button>
      <div className="grid-two">
                    <p className="nft">1</p>
                    <p className="nft">2</p>
                    <p className="nft">3</p>
                </div>
                <button className="layer-button">
        Связаться с экипажем
      </button>
        <BackButton onClick={() => navigate('/fork')} />
      </div>
      )}
      </div>
    );
  };
  
  export default CommPage;